import React, { useEffect, useState, useContext } from "react";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Tab, Tabs, TextField, Switch, FormControlLabel, Box, Tooltip, useTheme, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles, useTheme as useMuiTheme } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import useSettings from "../../hooks/useSettings";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import InfoIcon from "@material-ui/icons/Info";
import { withStyles } from "@material-ui/core/styles";
import api from "../../services/api";
import usePlans from "../../hooks/usePlans";
import * as sw from "../../serviceWorker";
import { AuthContext } from "../../context/Auth/AuthContext";

// Criação de um CustomTooltip com a cor do tema e fontSize 20
const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.primary.main, // usa a cor primária do tema
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fontSize: 20,
    borderRadius: 8,
    padding: "8px 12px",
    boxShadow: theme.shadows[3],
  },
  arrow: {
    color: theme.palette.primary.main,
  },
}))(Tooltip);

// Componente auxiliar para compor a label com o ícone de informação
const OptionLabelWithInfo = ({ labelText, tooltipText }) => {
  const theme = useMuiTheme();
  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      {labelText}
      <CustomTooltip title={tooltipText} arrow>
        <InfoIcon style={{ marginLeft: 5, fontSize: 20, color: theme.palette.primary.main }} />
      </CustomTooltip>
    </span>
  );
};

// Componente auxiliar para labels com badge de "NOVA FUNÇÃO"
const OptionLabelWithBadge = ({ labelText, tooltipText, isNew = false }) => {
  const theme = useMuiTheme();
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      {isNew && (
        <Chip
          label="NOVA FUNÇÃO"
          size="small"
          style={{
            backgroundColor: '#4caf50',
            color: 'white',
            fontSize: '10px',
            fontWeight: 'bold',
            height: '20px',
            animation: 'pulse 2s infinite'
          }}
        />
      )}
      {labelText}
      <CustomTooltip title={tooltipText} arrow>
        <InfoIcon style={{ marginLeft: 5, fontSize: 20, color: theme.palette.primary.main }} />
      </CustomTooltip>
    </span>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  selectContainer: {
    width: "80%",
    textAlign: "left",
  },
  formLabelBlack: {
    color: theme.mode === 'light' ? '#000' : theme.palette.text.primary,
  },
  tab: {
    backgroundColor: theme.mode === "light" ? "#f2f2f2" : "#7f7f7f",
    borderRadius: 4,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
  '@global': {
    '@keyframes pulse': {
      '0%': {
        boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.7)',
      },
      '70%': {
        boxShadow: '0 0 0 10px rgba(76, 175, 80, 0)',
      },
      '100%': {
        boxShadow: '0 0 0 0 rgba(76, 175, 80, 0)',
      },
    },
  },
}));

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;
  const classes = useStyles();

  // Estados gerais
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");
  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [UserRandom, setUserRandom] = useState("enabled");
  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState("enabled");
  // Criar tickets manualmente
  const [manualTicketCreation, setManualTicketCreation] = useState("disabled");
  // Flag: categorias/campos dinâmicos de tickets
  const [ticketCategoriesEnabled, setTicketCategoriesEnabled] = useState(false);
  // LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [lgpdMessage, setLGPDMessage] = useState("");
  const [lgpdLink, setLGPDLink] = useState("");
  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  // Outras configurações
  const [userCreation, setUserCreation] = useState("disabled");
  const [allowSignup, setAllowSignup] = useState("disabled");
  const [requiredTag, setRequiredTag] = useState("enabled");
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false);
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false);
  // Mensagens customizadas
  const [transferMessage, setTransferMessage] = useState("");
  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [AudioNotAcceptedMessage, setAudioNotAcceptedMessage] = useState("");
  const [showNotificationPending, setShowNotificationPending] = useState(false);
  // Novo: modo de despedida ao fechar na lista Aguardando
  const [closePendingListFarewellMode, setClosePendingListFarewellMode] = useState("always");

  // Estados de loading
  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);
  const [loadingAllowSignup, setLoadingAllowSignup] = useState(false);
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);
  const [loadingManualTicketCreation, setLoadingManualTicketCreation] = useState(false);
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false);
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false);
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false);
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);
  const [loadingAudioNotAcceptedMessage, setLoadingAudioNotAcceptedMessage] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);
  const [loadingClosePendingListFarewellMode, setLoadingClosePendingListFarewellMode] = useState(false);
  // Loading para a nova flag
  const [loadingTicketCategoriesEnabled, setLoadingTicketCategoriesEnabled] = useState(false);
  // Modal: bloqueio ao alternar Tickets Avançados com tickets ativos
  const [toggleBlockedModalOpen, setToggleBlockedModalOpen] = useState(false);
  const [toggleBlockMessage, setToggleBlockMessage] = useState("");
  const [toggleBlockCounts, setToggleBlockCounts] = useState({ session: 0, official: 0 });

  const { update: updateUserCreation } = useSettings();
  const { update } = useCompanySettings();
  const { getPlanCompany } = usePlans();
  const { user: authUser, socket } = useContext(AuthContext);

  // Plano da empresa (Kanban Avançado)
  const [planAdvanced, setPlanAdvanced] = useState(false);

  useEffect(() => {
    const loadPlan = async () => {
      try {
        const companyId = user?.companyId;
        if (!companyId) return;
        const planConfigs = await getPlanCompany(undefined, companyId);
        const flag = Boolean(planConfigs?.plan?.useKanbanAdvanced);
        setPlanAdvanced(flag);
      } catch (e) {
        setPlanAdvanced(false);
      }
    };
    loadPlan();
  }, [user, getPlanCompany]);

  // Assina eventos em tempo real para refletir travas/destravamentos sem F5
  useEffect(() => {
    const companyId = user?.companyId;
    if (!socket || !companyId) return;

    const onPlan = (data) => {
      if (data?.action !== "update") return;
      setPlanAdvanced(Boolean(data?.plan?.useKanbanAdvanced));
    };
    const onCompanySettings = (data) => {
      if (data?.action !== "update") return;
      const k = data?.setting?.key;
      const v = data?.setting?.value;
      if (k === "manualTicketCreation") setManualTicketCreation(v || "disabled");
      if (k === "ticketCategoriesEnabled") setTicketCategoriesEnabled(Boolean(v));
    };
    const chPlan = `company-${companyId}-plan`;
    const chSettings = `company-${companyId}-companySettings`;
    socket.on(chPlan, onPlan);
    socket.on(chSettings, onCompanySettings);
    return () => {
      socket.off(chPlan, onPlan);
      socket.off(chSettings, onCompanySettings);
    };
  }, [socket, user?.companyId]);

  // Push Notifications helpers
  const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || undefined;
  const [pushEnsured, setPushEnsured] = useState(false);

  async function subscribePushIfAllowed() {
    try {
      if (!('Notification' in window) || !('serviceWorker' in navigator) || !VAPID_PUBLIC_KEY) {
        return false;
      }
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return false;

      const registration = await sw.getServiceWorkerRegistration();
      if (!registration) return false;

      const existing = await registration.pushManager.getSubscription();
      const vapidUint8 = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
      const subscription = existing || await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidUint8
      });

      const deviceId = getDeviceId();
      await api.put(`/setting/webpush:user:${user.id}:${deviceId}`, { value: JSON.stringify(subscription) });
      return true;
    } catch (e) {
      console.error('Falha ao assinar push', e);
      return false;
    }
  }

  function getDeviceId() {
    const key = "deviceId";
    let v = localStorage.getItem(key);
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(key, v);
    }
    return v;
  }

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
  }

  const isSuper = () => user.super;
  const canCreateUsers = () => user.super || (user.companyId === 1 && user.profile === "admin");

  useEffect(() => {
    if (Array.isArray(oldSettings) && oldSettings.length) {
      const userPar = oldSettings.find((s) => s.key === "userCreation");
      if (userPar) {
        setUserCreation(userPar.value);
      }
      
      const allowSignupPar = oldSettings.find((s) => s.key === "allowSignup");
      if (allowSignupPar) {
        setAllowSignup(allowSignupPar.value);
      }
    }
  }, [oldSettings]);

  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value);
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
  if (key === "AudioNotAcceptedMessage") setAudioNotAcceptedMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);
      if (key === "manualTicketCreation") setManualTicketCreation(value || "disabled");
      if (key === "ticketCategoriesEnabled") setTicketCategoriesEnabled(Boolean(value));
      if (key === "closePendingListFarewellMode") setClosePendingListFarewellMode(value || "always");
    }
  }, [settings]);

  async function handleManualTicketCreation(value) {
    // Verifica se existem tickets ativos antes de alternar, usando contagem dedicada do backend.
    setLoadingManualTicketCreation(true);
    try {
      const { data } = await api.get("/tickets/active-count");
      const session = Number(data?.session || 0);
      const official = Number(data?.official || 0);

      // Bloqueio estrito: impedir alterar (ativar ou desativar) se existir QUALQUER ticket ativo (sessão ou oficial)
      const anyActive = session > 0 || official > 0;
      if (anyActive) {
        const turningOn = value === "enabled";
        setToggleBlockMessage(
          turningOn
            ? "Há tickets em atendimento (oficiais ou sessões). Feche ou arquive todos os tickets antes de ativar os Tickets Avançados."
            : "Há tickets em atendimento (oficiais ou sessões). Feche ou arquive todos os tickets antes de desativar os Tickets Avançados."
        );
        setToggleBlockCounts({ session, official });
        setToggleBlockedModalOpen(true);
        return;
      }

      // Sem bloqueio: permite a alteração normalmente.
      await update({ column: "manualTicketCreation", data: value });
      setManualTicketCreation(value);
    } catch (err) {
      console.error("Falha ao verificar contagem de tickets ativos", err);
    } finally {
      setLoadingManualTicketCreation(false);
    }
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({ column: "chatBotType", data: value });
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({ column: "lgpdMessage", data: value });
    setLoadingLGPDMessage(false);
  }

  // Handlers ausentes referenciados no JSX
  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({ key: "userCreation", value });
    setLoadingUserCreation(false);
  }

  async function handleChangeAllowSignup(value) {
    setAllowSignup(value);
    setLoadingAllowSignup(true);
    await updateUserCreation({ key: "allowSignup", value });
    setLoadingAllowSignup(false);
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({ column: "userRating", data: value });
    setLoadingUserRating(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({ column: "scheduleType", data: value });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({ column: "transferMessage", data: value });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({ column: "greetingAcceptedMessage", data: value });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setAcceptCallWhatsappMessage(value);
    setLoadingAcceptCallWhatsappMessage(true);
    await update({ column: "AcceptCallWhatsappMessage", data: value });
    setLoadingAcceptCallWhatsappMessage(false);
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({ column: "sendQueuePositionMessage", data: value });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleAudioNotAcceptedMessage(value) {
    setAudioNotAcceptedMessage(value);
    setLoadingAudioNotAcceptedMessage(true);
    await update({ column: "AudioNotAcceptedMessage", data: value });
    setLoadingAudioNotAcceptedMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({ column: "showNotificationPending", data: value });
    if (value === true) {
      await subscribePushIfAllowed();
    }
    setLoadingShowNotificationPending(false);
  }

  async function handleClosePendingListFarewellMode(value) {
    setClosePendingListFarewellMode(value);
    setLoadingClosePendingListFarewellMode(true);
    await update({ column: "closePendingListFarewellMode", data: value });
    setLoadingClosePendingListFarewellMode(false);
  }

  // Ensure we have a valid push subscription if setting is enabled (handles race when SW not ready yet)
  useEffect(() => {
    const ensure = async () => {
      if (!showNotificationPending || pushEnsured) return;
      // small delay to allow SW registration on slow devices/PWA launch
      await new Promise(r => setTimeout(r, 300));
      const ok = await subscribePushIfAllowed();
      setPushEnsured(true);
      return ok;
    };
    ensure();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNotificationPending]);

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({ column: "lgpdLink", data: value });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({ column: "lgpdDeleteMessage", data: value });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({ column: "lgpdConsent", data: value });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({ column: "lgpdHideNumber", data: value });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({ column: "sendGreetingAccepted", data: value });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({ column: "userRandom", data: value });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({ column: "sendMsgTransfTicket", data: value });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({ column: "acceptCallWhatsapp", data: value });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({ column: "sendSignMessage", data: value });
    localStorage.setItem("sendSignMessage", value === "enabled");
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({ column: "sendGreetingMessageOneQueues", data: value });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({ column: "sendQueuePosition", data: value });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({ column: "sendFarewellWaitingTicket", data: value });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({ column: "acceptAudioMessageContact", data: value });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleTicketCategoriesToggle(value) {
    setTicketCategoriesEnabled(value);
    setLoadingTicketCategoriesEnabled(true);
    await update({ column: "ticketCategoriesEnabled", data: value });
    setLoadingTicketCategoriesEnabled(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({ column: "enableLGPD", data: value });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({ column: "requiredTag", data: value });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({ column: "closeTicketOnTransfer", data: value });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({ column: "DirectTicketsToWallets", data: value });
    setLoadingDirectTicketsToWallets(false);
  }

  async function handleAllowSignup(value) {
    setAllowSignup(value);
    setLoadingUserCreation(true);
    await updateUserCreation({ key: "allowSignup", value });
    setLoadingUserCreation(false);
  }

  return (
    <>
      {/* Modal de bloqueio ao alternar Tickets Avançados quando há tickets ativos */}
      <Dialog open={toggleBlockedModalOpen} onClose={() => setToggleBlockedModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Não é possível alterar agora</DialogTitle>
        <DialogContent>
          <div>
            {toggleBlockMessage || (
              "Há tickets em atendimento (abertos, pendentes ou em grupo). Feche ou arquive todos os tickets antes de ativar ou desativar 'Tickets Avançados'."
            )}
          </div>
          <div style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
            Oficiais: {toggleBlockCounts.official} • Sessões: {toggleBlockCounts.session}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setToggleBlockedModalOpen(false)} color="primary" autoFocus>
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container direction="column" spacing={2}>
        {/* CRIAÇÃO DE COMPANY/USERS */}
        {isSuper() && (
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={userCreation === "enabled"}
                  onChange={async (e) => {
                    const newValue = e.target.checked ? "enabled" : "disabled";
                    await handleChangeUserCreation(newValue);
                  }}
                  color="primary"
                />
              }
              label={
                <OptionLabelWithInfo
                  labelText={i18n.t("settings.settings.options.creationCompanyUser")}
                  tooltipText="Habilita a criação de empresas/usuários para usuários ADM. Válido apenas para a conta 'Minha empresa'."
                />
              }
            />
            {loadingUserCreation && (
              <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
            )}
          </Grid>
        )}
        
        {/* PERMITIR CADASTRO PÚBLICO */}
        {isSuper() && (
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={allowSignup === "enabled"}
                  onChange={async (e) => {
                    const newValue = e.target.checked ? "enabled" : "disabled";
                    await handleChangeAllowSignup(newValue);
                  }}
                  color="primary"
                />
              }
              label={
                <OptionLabelWithInfo
                  labelText="Permitir Cadastro Público"
                  tooltipText="Habilita ou desabilita o cadastro de novos usuários através da página de registro. Quando desabilitado, o link 'Criar conta' não aparece na página de login."
                />
              }
            />
            {loadingAllowSignup && (
              <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
            )}
          </Grid>
        )}
        {/* AVALIAÇÕES */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={userRating === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleChangeUserRating(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText="Avaliações"
                tooltipText="Habilita ou desabilita as avaliações. Configure na guia NPS em cada conexão individualmente."
              />
            }
          />
          {loadingUserRating && <FormHelperText>Atualizando...</FormHelperText>}
        </Grid>
  {/* TICKETS AVANÇADOS */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={manualTicketCreation === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleManualTicketCreation(newValue);
                }}
                color="primary"
                disabled={!planAdvanced || loadingManualTicketCreation}
              />
            }
            label={
              <OptionLabelWithBadge
    labelText="Tickets Avançados"
                tooltipText="Quando habilitado, novos atendimentos começam como sessão (não-oficiais) e o atendente pode oficializar manualmente pela conversa."
                isNew={true}
              />
            }
          />
          {!planAdvanced && (
            <FormHelperText>
        Ative o Kanban Avançado no plano para ativar Tickets Avançados.
            </FormHelperText>
          )}
          {loadingManualTicketCreation && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>

        {/* CATEGORIAS E CAMPOS DINÂMICOS DE TICKETS */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={ticketCategoriesEnabled === true}
                onChange={async (e) => {
                  const newValue = e.target.checked;
                  await handleTicketCategoriesToggle(newValue);
                }}
                color="primary"
                disabled={manualTicketCreation !== "enabled"}
              />
            }
            label={
              <OptionLabelWithBadge
                labelText="Categorias e Campos Dinâmicos de Tickets"
                tooltipText="Habilita recursos de categorias, campos personalizados, responsáveis múltiplos, comentários e checklists nos tickets."
                isNew={true}
              />
            }
          />
      {manualTicketCreation !== "enabled" && (
            <FormHelperText>
        Habilite "Tickets Avançados" para alterar esta opção.
            </FormHelperText>
          )}
          {loadingTicketCategoriesEnabled && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>

        {/* AGENDAMENTO DE EXPEDIENTE */}
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {i18n.t("settings.settings.options.officeScheduling")}
            </FormLabel>
            <RadioGroup
              style={{ marginLeft: 40 }}
              aria-label="scheduleType"
              name="scheduleType"
              value={scheduleType}
              onChange={(e) => handleScheduleType(e.target.value)}
            >
              <FormControlLabel
                value="disabled"
                control={<Radio />}
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.options.disabled")}
                    tooltipText="Não habilita o gerenciamento de horários da empresa."
                  />
                }
              />
              <FormControlLabel
                value="queue"
                control={<Radio />}
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.options.queueManagement")}
                    tooltipText="Exibe a guia de horário em todas as filas/setores. Configure na página de filas/setores para cada fila horários individuais."
                  />
                }
              />
              <FormControlLabel
                value="company"
                control={<Radio />}
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.options.companyManagement")}
                    tooltipText="Exibe o horário geral do expediente da empresa."
                  />
                }
              />
              <FormControlLabel
                value="connection"
                control={<Radio />}
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.options.connectionManagement")}
                    tooltipText="Exibe a guia de horário individual para cada conexão. Configure na página de conexões em cada uma das conexões."
                  />
                }
              />
            </RadioGroup>
            {loadingScheduleType && (
              <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={SendGreetingAccepted === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleSendGreetingAccepted(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.sendGreetingAccepted")}
                tooltipText="Define se a saudação será enviada ao aceitar o ticket."
              />
            }
          />
          {loadingSendGreetingAccepted && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.selectContainer}>
            <TextField
              style={{ marginLeft: 40 }}
              id="greetingAcceptedMessage"
              name="greetingAcceptedMessage"
              margin="dense"
              multiline
              label={i18n.t("settings.settings.customMessages.greetingAcceptedMessage")}
              variant="outlined"
              value={greetingAcceptedMessage}
              required={SendGreetingAccepted === "enabled"}
              onChange={async (e) => handleGreetingAcceptedMessage(e.target.value)}
            />
            <FormHelperText>
              {loadingGreetingAcceptedMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ESCOLHER OPERADOR ALEATÓRIO */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={UserRandom === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleUserRandom(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.userRandom")}
                tooltipText="Habilita a seleção aleatória de operador para o ticket quando o contato escolhe uma fila/setor."
              />
            }
          />
          {loadingUserRandom && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* ENVIAR MENSAGEM DE TRANSFERÊNCIA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={SettingsTransfTicket === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleSettingsTransfTicket(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.sendMsgTransfTicket")}
                tooltipText="Habilita o envio da mensagem de transferência do ticket."
              />
            }
          />
          {loadingSettingsTransfTicket && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.selectContainer}>
            <TextField
              style={{ marginLeft: 40 }}
              id="transferMessage"
              name="transferMessage"
              margin="dense"
              multiline
              label={i18n.t("settings.settings.customMessages.transferMessage")}
              variant="outlined"
              value={transferMessage}
              required={SettingsTransfTicket === "enabled"}
              onChange={async (e) => handletransferMessage(e.target.value)}
            />
            <FormHelperText>
              {loadingTransferMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* TIPO DO BOT */}
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {i18n.t("settings.settings.options.chatBotType")}
            </FormLabel>
            <RadioGroup
              style={{ marginLeft: 40 }}
              aria-label="chatBotType"
              name="chatBotType"
              value={chatBotType}
              onChange={(e) => handleChatBotType(e.target.value)}
            >
              <FormControlLabel
                value="text"
                control={<Radio color="primary" />}
                label={
                  <OptionLabelWithInfo
                    labelText="Texto"
                    tooltipText="Apenas a opção Texto está disponível no momento."
                  />
                }
              />
              {/* Futuras opções podem ser adicionadas aqui */}
            </RadioGroup>
            {loadingScheduleType && (
              <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        {/* AVISO SOBRE LIGAÇÃO DO WHATSAPP */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={AcceptCallWhatsapp === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleAcceptCallWhatsapp(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.acceptCallWhatsapp")}
                tooltipText="Informa ao contato se as ligações via WhatsApp são aceitas."
              />
            }
          />
          {loadingAcceptCallWhatsapp && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl className={classes.selectContainer}>
            <TextField
              style={{ marginLeft: 40 }}
              id="AcceptCallWhatsappMessage"
              name="AcceptCallWhatsappMessage"
              margin="dense"
              multiline
              label={i18n.t("settings.settings.customMessages.AcceptCallWhatsappMessage")}
              variant="outlined"
              required={AcceptCallWhatsapp === "disabled"}
              value={AcceptCallWhatsappMessage}
              onChange={async (e) => handleAcceptCallWhatsappMessage(e.target.value)}
            />
            <FormHelperText>
              {loadingAcceptCallWhatsappMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* HABILITAR PARA O ATENDENTE RETIRAR A ASSINATURA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={sendSignMessage === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleSendSignMessage(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.sendSignMessage")}
                tooltipText="Permite que o atendente remova a assinatura automática da mensagem."
              />
            }
          />
          {loadingSendSignMessage && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={sendGreetingMessageOneQueues === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleSendGreetingMessageOneQueues(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
                tooltipText="Exibe a saudação quando há somente uma fila disponível."
              />
            }
          />
          {loadingSendGreetingMessageOneQueues && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* ENVIAR MENSAGEM COM A POSIÇÃO DA FILA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={sendQueuePosition === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleSendQueuePosition(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.sendQueuePosition")}
                tooltipText="Envia uma mensagem automática informando a posição atual do contato na fila."
              />
            }
          />
          {loadingSendQueuePosition && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
          <FormControl className={classes.selectContainer}>
            <TextField
              style={{ marginLeft: 40 }}
              id="sendQueuePositionMessage"
              name="sendQueuePositionMessage"
              margin="dense"
              multiline
              required={sendQueuePosition === "enabled"}
              label={i18n.t("settings.settings.customMessages.sendQueuePositionMessage")}
              variant="outlined"
              value={sendQueuePositionMessage}
              onChange={async (e) => handlesendQueuePositionMessage(e.target.value)}
            />
            <FormHelperText>
              {loadingSendQueuePositionMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM DE DESPEDIDA NO AGUARDANDO */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={sendFarewellWaitingTicket === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleSendFarewellWaitingTicket(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
                tooltipText="Envia uma mensagem de despedida enquanto o ticket está na guia aguardando."
              />
            }
          />
          {loadingSendFarewellWaitingTicket && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>

        {/* MODO DE DESPEDIDA AO FECHAR INDIVIDUAL (NOVA FUNÇÃO) */}
        <Grid item xs={12}>
          <FormControl component="fieldset" className={classes.selectContainer}>
            <FormLabel component="legend" className={classes.formLabelBlack}>
              <OptionLabelWithBadge
                labelText="Modo de despedida ao fechar individual em atendendo."
                tooltipText="Define se, ao fechar um ticket individualmente, deve sempre enviar a mensagem de despedida, perguntar ao atendente, ou nunca enviar."
                isNew={true}
              />
            </FormLabel>
            <RadioGroup
              style={{ marginLeft: 40 }}
              aria-label="closePendingListFarewellMode"
              name="closePendingListFarewellMode"
              value={closePendingListFarewellMode}
              onChange={(e) => handleClosePendingListFarewellMode(e.target.value)}
            >
              <FormControlLabel value="always" control={<Radio color="primary" />} label="Sempre enviar" />
              <FormControlLabel value="ask" control={<Radio color="primary" />} label="Perguntar" />
              <FormControlLabel value="never" control={<Radio color="primary" />} label="Nunca enviar" />
            </RadioGroup>
            {loadingClosePendingListFarewellMode && (
              <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        {/* ACCEPT AUDIO MESSAGE CONTACT */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={acceptAudioMessageContact === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleAcceptAudioMessageContact(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.acceptAudioMessageContact")}
                tooltipText="Informa ao contato se é possivel ou não ouvir mensagens de audio."
              />
            }
          />
          {loadingAcceptAudioMessageContact && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* MENSAGEM AUTOMÁTICA ÁUDIO NÃO ACEITO - POSICIONADA APÓS O SWITCH GLOBAL */}
        <Grid item xs={12}>
          <FormControl className={classes.selectContainer}>
            <TextField
              style={{ marginLeft: 40 }}
              id="AudioNotAcceptedMessage"
              name="AudioNotAcceptedMessage"
              margin="dense"
              multiline
              label={i18n.t("settings.settings.customMessages.AudioNotAcceptedMessage")}
              variant="outlined"
              value={AudioNotAcceptedMessage}
              onChange={async (e) => handleAudioNotAcceptedMessage(e.target.value)}
              placeholder="Texto enviado automaticamente quando receber áudio com áudio desativado"
            />
            <FormHelperText>
              {loadingAudioNotAcceptedMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        {/* TAG OBRIGATÓRIA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={requiredTag === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleRequiredTag(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.requiredTag")}
                tooltipText="Define a tag obrigatória para novos tickets, ao fechar será obrigatório adicionar uma TAG na conversa."
              />
            }
          />
          {loadingRequiredTag && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* FECHAR TICKET AO TRANSFERIR */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={closeTicketOnTransfer === true}
                onChange={async (e) => {
                  const newValue = e.target.checked;
                  await handleCloseTicketOnTransfer(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.closeTicketOnTransfer")}
                tooltipText="Fecha automaticamente o ticket ao transferir. Só funciona se não definir um atendente especifico no momento da traferência."
              />
            }
          />
          {loadingCloseTicketOnTransfer && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* DIRECT TICKETS TO WALLETS */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={directTicketsToWallets === true}
                onChange={async (e) => {
                  const newValue = e.target.checked;
                  await handleDirectTicketsToWallets(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithBadge
                labelText="Direcionamento Automático para Carteiras"
                tooltipText="Direciona automaticamente novos tickets para os atendentes configurados nas carteiras dos contatos."
                isNew={true}
              />
            }
          />
          {loadingDirectTicketsToWallets && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* NOTIFICAÇÃO DE PENDÊNCIA */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={showNotificationPending === true}
                onChange={async (e) => {
                  const newValue = e.target.checked;
                  await handleShowNotificationPending(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.showNotificationPending")}
                tooltipText="Exibe notificações para tickets pendentes."
              />
            }
          />
          {loadingShowNotificationPending && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
        {/* ENABLE LGPD */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={enableLGPD === "enabled"}
                onChange={async (e) => {
                  const newValue = e.target.checked ? "enabled" : "disabled";
                  await handleEnableLGPD(newValue);
                }}
                color="primary"
              />
            }
            label={
              <OptionLabelWithInfo
                labelText={i18n.t("settings.settings.options.enableLGPD")}
                tooltipText="Habilita ou desabilita as regras da LGPD."
              />
            }
          />
          {loadingEnableLGPD && (
            <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
          )}
        </Grid>
      </Grid>
      <br />
      {/* ----------------- LGPD ----------------- */}
      {enableLGPD === "enabled" && (
        <>
          <Grid container direction="column" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12}>
              <Tabs
                value={0}
                indicatorColor="primary"
                textColor="primary"
                scrollButtons="on"
                variant="scrollable"
                className={classes.tab}
              >
                <Tab label={i18n.t("settings.settings.LGPD.title")} />
              </Tabs>
            </Grid>
          </Grid>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12}>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdMessage"
                  name="lgpdMessage"
                  margin="dense"
                  multiline
                  rows={3}
                  label={
                    <OptionLabelWithInfo
                      labelText={i18n.t("settings.settings.LGPD.welcome")}
                      tooltipText="Mensagem de boas-vindas da LGPD."
                    />
                  }
                  variant="outlined"
                  value={lgpdMessage}
                  onChange={async (e) => handleLGPDMessage(e.target.value)}
                />
                <FormHelperText>
                  {loadinglgpdMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdLink"
                  name="lgpdLink"
                  margin="dense"
                  label={
                    <OptionLabelWithInfo
                      labelText={i18n.t("settings.settings.LGPD.linkLGPD")}
                      tooltipText="Link para mais informações da LGPD."
                    />
                  }
                  variant="outlined"
                  value={lgpdLink}
                  onChange={async (e) => handleLGPDLink(e.target.value)}
                />
                <FormHelperText>
                  {loadingLGPDLink && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={lgpdDeleteMessage === "enabled"}
                    onChange={async (e) => {
                      const newValue = e.target.checked ? "enabled" : "disabled";
                      await handleLGPDDeleteMessage(newValue);
                    }}
                    color="primary"
                  />
                }
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}
                    tooltipText="Oculta as mensagens apagadas conforme a LGPD."
                  />
                }
              />
              {loadingLGPDDeleteMessage && (
                <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={lgpdConsent === "enabled"}
                    onChange={async (e) => {
                      const newValue = e.target.checked ? "enabled" : "disabled";
                      await handleLGPDConsent(newValue);
                    }}
                    color="primary"
                  />
                }
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.LGPD.alwaysConsent")}
                    tooltipText="Sempre solicitar o consentimento para o tratamento dos dados."
                  />
                }
              />
              {loadingLGPDConsent && (
                <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={lgpdHideNumber === "enabled"}
                    onChange={async (e) => {
                      const newValue = e.target.checked ? "enabled" : "disabled";
                      await handleLGPDHideNumber(newValue);
                    }}
                    color="primary"
                  />
                }
                label={
                  <OptionLabelWithInfo
                    labelText={i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
                    tooltipText="Oculta ou exibe o número do usuário conforme a LGPD."
                  />
                }
              />
              {loadingLGPDHideNumber && (
                <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
